"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubtextTypography = exports.FormControlLabelContainer = void 0;
var system_1 = require("@mui/system");
var FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
var colors_1 = require("../ThemeProvider/colors");
var Typography_1 = __importDefault(require("../Typography"));
exports.FormControlLabelContainer = (0, system_1.styled)(FormControlLabel_1.default)(function (_a) {
    var disabled = _a.disabled;
    return ({
        maxWidth: 'fit-content',
        columnGap: '2px',
        '&:hover .MuiButtonBase-root': {
            backgroundColor: disabled
                ? 'transparent'
                : "".concat(colors_1.tannerSemantic.info['200'], "4d"),
            transition: disabled ? 'none' : 'background-color 300ms ease-out',
        },
        '&:not(:hover)': {
            ' .MuiButtonBase-root': {
                transition: disabled ? 'none' : 'background-color 300ms ease-out',
            },
        },
        '&:focus-visible': {
            outlineOffset: '3px',
            outline: "3px solid  ".concat(colors_1.tannerSemantic.info.color),
            borderRadius: '3px',
            ' .MuiButtonBase-root': {
                backgroundColor: disabled
                    ? 'transparent'
                    : "".concat(colors_1.tannerSemantic.info.background, "4d"),
                transition: disabled ? 'none' : 'background-color 300ms ease-out',
            },
        },
    });
});
exports.SubtextTypography = (0, system_1.styled)(Typography_1.default)({
    color: colors_1.tannerGray[600],
});
//# sourceMappingURL=styles.js.map